
// Main Navigation
$(document).ready(function(){
  $('.site-nav__childlist-item ul').hover(function () { 
      $(".site-nav__childlist-item:last-child").addClass($(this)[0].getAttribute("data-id"));
  });

  $('.site-nav__childlist-item ul').mouseleave(function(){
      $(".site-nav__childlist-item:last-child").removeClass($(this)[0].getAttribute("data-id"));
  });
    $('.mobile-nav__sublist-link').on('click', function(){
        $(this).next().toggleClass('hide');
        $(this).parent().toggleClass('open');
    })
});

// Remove href attribute for menu with child
$(document).ready(function(){
  $(".site-nav--has-dropdown > a").click(function(event){
		event.preventDefault();
    });
});

$(document).ready(function(){
  $("button.mobile-nav__link").click(function(){
        $('#MobileNav > li').removeClass('isactive')
        if (!$(this).hasClass('back')) {
            $(this).parents('ul').addClass('menu-open');
            $(this).parent().addClass('isactive');
        } else {
            $(this).parents('ul').removeClass('menu-open');
        }
    });
});
// Ends navigation style

$(document).ready(function() {
  $('.tt-input-counter:not(.disabled)').find('.minus-btn, .plus-btn').click(function( e ) {
    var $input = $(this).parent().find('input');
    var count = parseInt($input.val(), 10) + parseInt(e.currentTarget.className === 'plus-btn' ? 1 : -1, 10);
    $input.val(count).change();
  });
  $('.tt-input-counter').find("input").change(function() {
    var _ = $(this);
    var min = 0;
    var val = parseInt(_.val(), 10);
    var max = parseInt(_.attr('size'), 10);
    val = Math.min(val, max);
    val = Math.max(val, min);
    _.val(val);
  })
  .on("keypress", function( e ) {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  });
});

$(document).ready(function(){
    $("body").on("click", "input.single-option-selector", function(){
        $(this).parents('.product-option').find('label').removeClass('active');
        $(this).parents().addClass('active');
        $(this).parents('.product-option').find('.color-text').text($(this).val());

        var getImage = $(this).attr('data-get-image');
        var getProductId = $(this).attr('data-get-productid');
        var getSection = $(this).attr('data-get-section');
        // ProductCardImageWrapper-header-7272317583435
        $("#ProductCardImageWrapper-"+getSection+"-"+getProductId+" > div > div").addClass('hide');
        $("."+getImage+" .product-single__photo:first").removeClass('hide');

    })
});

// GEOMETRY

$(document).ready(function() {
    var image = $("#geometryImage");
    var imageReal = $("#geometryRealImage");
    var baseImgUrl = image.attr('data-base-url');
    var dataCache = image.attr('data-cache');
    $(".geometry__row-hover").hover(function(){
        $(this).css("color", "#b53737");
        imageReal.hide();
        image.show();
        var geometryImage = $(this).attr('data-geometry-id');
        if (dataCache == '') {
            image.attr('src', baseImgUrl+'-'+geometryImage+'.png')
        } else {
            image.attr('src', baseImgUrl+'-'+geometryImage+'.png'+dataCache)
        }
    }, function(){
        imageReal.show();
        image.hide();
        $(this).css("color", "#1e1e1e");
    });


    // Search result
    $('.nav-search li a').on("click", function(ev){
        var a = $(this), 
        pageIndex = a.attr('data-page'), 
        searchTerm = $("#SearchInput").val(), 
        searchType = a.attr('data-type');
        searchType != 'product' ? $('.total-product').hide() : $('.total-product').show();
        ev.preventDefault();
        $('.result-content').hide();
        $('.nav-search li').removeClass('active');
        a.parents('li').addClass('active');
        $('#result-'+searchType).show();
        if (pageIndex != '0') {
            $('.image-loader').show();
            $.ajax({
                url: '/search?type='+searchType+'&page='+pageIndex+'&q='+searchTerm+'&view=json',
            }).done(function(T) {
                $('#result-'+searchType).empty();
                $('#result-'+searchType).append(T);
                $('.image-loader').hide();
                a.attr('data-page', '0');
            });
        }
    })
})

// Loader
